






























import Vue from 'vue';

export default Vue.extend({
    name: 'text-header',
    props: {
        title: { type: String, required: true },
        visible: { type: Boolean, default: () : boolean => true },
    },
    data() { return { myVisible: this.visible, clicked: false }; },
});
